import React from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
  showCurrency?: boolean;
}
function getCurrencyInfo(): {
  currency: string;
  locale: string;
} {
  if (typeof navigator === 'undefined') {
    return {
      currency: 'EUR',
      locale: 'es-ES'
    };
  }
  const language = navigator.language || 'es-ES';
  if (language.startsWith('es')) {
    return {
      currency: 'EUR',
      locale: 'es-ES'
    };
  }
  if (language === 'en-US') {
    return {
      currency: 'USD',
      locale: 'en-US'
    };
  }
  if (language === 'en-GB') {
    return {
      currency: 'GBP',
      locale: 'en-GB'
    };
  }
  if (language.startsWith('pt-BR')) {
    return {
      currency: 'BRL',
      locale: 'pt-BR'
    };
  }
  return {
    currency: 'EUR',
    locale: 'es-ES'
  };
}
export function PriceDisplay({
  amount,
  className = '',
  showCurrency = true
}: PriceDisplayProps) {
  const {
    currency,
    locale
  } = getCurrencyInfo();
  const formatted = new Intl.NumberFormat(locale, {
    style: showCurrency ? 'currency' : 'decimal',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  return <span className={className} data-id="element-271">{formatted}</span>;
}